import Maintenance from "@/features/Common/components/Maintenance";

export default function MaintenancePage() {
  return <Maintenance />;
}
